import React from "react";
import MaterialIcon from "./MaterialIcon";
import "./MessageContextMenu.css";

// Hover bar of a chat bubble (web stand-in for the mobile long-press): the two quick actions
// (react, reply) and "more", which opens the full message menu (components/chat/MessageMenuPro).
// Right-click on the bubble opens the same menu. The bubble itself carries no bookmark or
// reaction marks any more (mobile Pro): the bookmark lives in the menu's top row.

/** No bookmark mark beside bubbles any more (mobile Pro); kept as a no-op for old imports. */
export function MessageBookmarkCorner() {
  return null;
}

const MessageContextMenu = React.memo(({ side = "left", strings = {}, labels = {}, onReaction, onReply, onMore }) => {
  const label = (key, fallback) => labels[key] || strings[key] || fallback;
  return (
    <div className={`contextMenu ${side}-context kjc-hoverbar`} onContextMenu={(e) => e.stopPropagation()}>
      {onReaction && (
        <button
          type="button"
          className="kj-btn kj-btn--icon kj-btn--neutral message-action-btn"
          onClick={(e) => {
            e.stopPropagation();
            onReaction(e);
          }}
          title={label("add_reaction", "Add reaction")}
          aria-label={label("add_reaction", "Add reaction")}
        >
          <MaterialIcon icon="add_reaction" size={20} weight={300} />
        </button>
      )}
      {onReply && (
        <button
          type="button"
          className="kj-btn kj-btn--icon kj-btn--neutral message-action-btn"
          onClick={(e) => {
            e.stopPropagation();
            onReply(e);
          }}
          title={label("reply", "Reply")}
          aria-label={label("reply", "Reply")}
        >
          <MaterialIcon icon="reply" size={20} weight={300} />
        </button>
      )}
      {onMore && (
        <button
          type="button"
          className="kj-btn kj-btn--icon kj-btn--neutral message-action-btn"
          onClick={(e) => {
            e.stopPropagation();
            onMore(e);
          }}
          title={label("more_options", "More options")}
          aria-label={label("more_options", "More options")}
          aria-haspopup="menu"
        >
          <MaterialIcon icon="more_horiz" size={20} weight={300} />
        </button>
      )}
    </div>
  );
});

MessageContextMenu.displayName = "MessageContextMenu";

export default MessageContextMenu;
